import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {CashReports} from "../model/cashReports";
import {CashReport} from "../model/cashReport";



@Injectable({ providedIn: 'root' })
export class CashReportItemService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/cash-reports/items`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/cash-reports/items/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    delete(id: string, reason: string) {
        return this.http.post(`${environment.apiEndpoint}/v1/cash-reports/items/` + id, {reason: reason}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            })
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
